import React, { useEffect, useMemo, useState } from 'react';
import * as styles from './HomeV2.module.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Location from '../../../components/Location/Location';
import RedNumberText from '../../../components/RedNumberText/RedNumberText';
import LinkCardV1 from '../../../components/LinkCard/V1/LinkCardV1';
import PhonePopup from '../../../components/PhonePopup/PhonePopup';
import { usePhonePopup } from '../../../components/PhonePopup/hooks/usePhonePopup';
import { formatIncrementedValue, formatLinksV2 } from '../helpers';

const HomeV2 = ({ pageContext }) => {
  const [subheader, setSubheader] = useState(
    formatIncrementedValue(pageContext.data.V2_Subheader)
  );

  const initialLinks = useMemo(() => formatLinksV2(pageContext), [pageContext]);
  const [links, setLinks] = useState(initialLinks);

  useEffect(() => {
    const timeout1 = setTimeout(() => {
      setLinks(formatLinksV2(pageContext, -1));
      setSubheader(formatIncrementedValue(pageContext.data.V2_Subheader, -1));
    }, 1 * 1000);

    const timeout2 = setTimeout(() => {
      setLinks(formatLinksV2(pageContext, -2));
      setSubheader(formatIncrementedValue(pageContext.data.V2_Subheader, -2));
    }, 3 * 1000);

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, [pageContext]);

  const backgroundImage = useMemo(
    () =>
      getImage(
        pageContext.data.V2BackgroundImage?.localFiles?.[0]?.childImageSharp
      ),
    [pageContext.data.V2BackgroundImage]
  );

  const coverImage = useMemo(
    () =>
      getImage(
        pageContext.data.Cover_Photo_Desktop?.localFiles?.[0]?.childImageSharp
      ),
    [pageContext.data.Cover_Photo_Desktop]
  );

  const { isPhonePopupVisible, phoneNumber, closePhonePopup } = usePhonePopup(
    pageContext.data
  );

  return (
    <div className={styles.container}>
      <div
        className={styles.mainCard}
        style={{
          backgroundColor: !pageContext.data.V2BackgroundImage
            ? (pageContext.data.V2BackgroundColor ?? '#33aa331a')
            : 'transparent',
        }}
      >
        {backgroundImage && (
          <GatsbyImage
            image={backgroundImage}
            alt="Background image"
            className={styles.backgroundImage}
          />
        )}

        <div className={styles.content}>
          <div className={styles.profileHeaderContainer}>
            {coverImage && (
              <GatsbyImage
                image={coverImage}
                alt="Cover Photo Mobile"
                className={styles.profilePhoto}
              />
            )}

            <h1 className={styles.headerTitle}>{pageContext.data.Full_Name}</h1>
            <h2 className={styles.subHeader}>
              <RedNumberText {...subheader} />
            </h2>

            {pageContext.data.V2Location && <Location />}
          </div>

          <div className={styles.links}>
            {links.map((linkData) => (
              <LinkCardV1
                key={linkData.link}
                linkData={linkData}
                disableDeeplinks={pageContext.data.Disable_Deeplinks}
                creatorName={pageContext.data.Name}
              />
            ))}
          </div>
        </div>
      </div>

      {isPhonePopupVisible && (
        <PhonePopup phoneNumber={phoneNumber} onClose={closePhonePopup} />
      )}
    </div>
  );
};

export default HomeV2;
